<template>
  <!--------------------------------------
    Generate a QR code and display it as a canvas node.
  ---------------------------------------->
  <div id="qr-code">
  </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'QrCode',

  props: {
    url: { type: String, default: '' },
    size: { type: Number, default: 80 } // pixel width & height
  },

  mounted () {
    if (this.url !== '') {
      this.generateQR()
    }
  },

  methods: {
    async generateQR () {
      const container = document.getElementById('qr-code')

      // Remove any existing QR code
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }

      try {
        const opts = { 
          margin: 0,
          width: this.size,
          color: {
            dark: '#404040'
          }
        }

        // Generate and append the canvas QR code
        await QRCode.toCanvas(this.url, opts, function (err, canvas) {
          if (err) throw err
          container.appendChild(canvas)
        })
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>

<style lang="scss">
#qr-code {
  min-width: 80px;
  min-height: 80px;
}
</style>